import $ from 'cash-dom';
import animate from './animate';
import PopupScanCheck from './PopupScanCheck';
import Cookie from 'js-cookie';
import Device from './device';

class PopupMobileButton {
	constructor({ $button, $exitPopup = null, onRequestContent = null }) {
		this._$button = $button;
		this._$overlay = $button.next('.popup-mb-overlay');
		if (!this._$overlay.length) {
			this._$overlay = $('.popup-mb-overlay');
		}
		this._$exitPopup = $exitPopup;
		this._$mobilePopupHolder = $('#mobile-popup-holder');
		this._isPopupOpen = false;
		this._popupReady = false;
		this._pendingShow = false;
		this._PopupScanCheck = null;
		this._onActivity = null;
		this._onRequestContent = typeof onRequestContent === 'function' ? onRequestContent : null;

		this._moveToBody();
		this._refreshDomRefs();
		this._initMobileButtonShow();

		if ($exitPopup && $exitPopup.length) {
			this._setExitPopupContent($exitPopup);
		}
	}

	_refreshDomRefs() {
		this._$mobilePopupHolder = $('#mobile-popup-holder');
		if (!this._$overlay.length) {
			this._$overlay = this._$mobilePopupHolder.closest('.popup-mb-overlay');
		}
	}

	_moveToBody() {
		if (this._$overlay.length && this._$overlay.parent()[0] !== document.body) {
			$('body').append(this._$overlay);
		}
		if (this._$button.length && this._$button.parent()[0] !== document.body) {
			$('body').append(this._$button);
		}
	}

	_setExitPopupContent($exitPopup) {
		this._refreshDomRefs();
		this._$exitPopup = $exitPopup;
		const $clonedContent = $exitPopup.children().clone();
		if ($clonedContent.hasClass('vpnmentor-exit-intent')) {
			$clonedContent.attr('data-btn-name', 'Exit Intent - Mobile Popup Overlay');
			$clonedContent.attr('data-ga-label', 'Exit Intent - Mobile Popup Overlay');
		}
		this._$mobilePopupHolder.find('.mobile-popup').empty().append($clonedContent);
		this._popupReady = this._$mobilePopupHolder.find('.mobile-popup').children().length > 0;
		this._initPopupScanCheck();

		if (this._pendingShow && this._popupReady) {
			this._pendingShow = false;
			this._showPopup();
		}
	}

	setExitPopupHtml(content) {
		if (!content) {
			return;
		}

		let $exitPopup;
		if (typeof content === 'string') {
			if (!content.trim()) {
				return;
			}
			$exitPopup = $(content.trim());
		} else if (typeof content === 'object' && content instanceof $) {
			$exitPopup = content;
		}

		if (!$exitPopup || !$exitPopup.length) {
			return;
		}

		this._setExitPopupContent($exitPopup);
	}

	_initMobileButtonShow() {
		const $secondVendor = $('.vendors-list .ppc-single-vendor.ppc-vendor-2').first();
		const $target = $secondVendor.length ? $secondVendor : $('.vendors-list .ppc-single-vendor').eq(1);

		if (!$target.length) {
			this._showButon();
			return;
		}

		const $headerInner = $('.header-inner');
		const headerHeight = $headerInner.length ? $headerInner.outerHeight() : 0;
		let revealed = false;

		const reveal = () => {
			if (revealed) {
				return;
			}
			revealed = true;
			this._showButon();
			this._teardownRevealListeners();
		};

		this._onActivity = () => {
			const el = $target[0];
			if (!el) {
				return;
			}

			const rect = el.getBoundingClientRect();
			// User has scrolled past the 2nd vendor (same rule as VPNS-71).
			if (rect.bottom <= headerHeight) {
				reveal();
			}
		};

		window.addEventListener('scroll', this._onActivity, { passive: true });
		window.addEventListener('touchmove', this._onActivity, { passive: true });
		window.addEventListener('resize', this._onActivity, { passive: true });
		window.addEventListener('orientationchange', this._onActivity, { passive: true });
	}

	_teardownRevealListeners() {
		if (this._onActivity) {
			window.removeEventListener('scroll', this._onActivity);
			window.removeEventListener('touchmove', this._onActivity);
			window.removeEventListener('resize', this._onActivity);
			window.removeEventListener('orientationchange', this._onActivity);
			this._onActivity = null;
		}
	}

	_initPopupScanCheck() {
		if (!this._PopupScanCheck) {
			this._PopupScanCheck = new PopupScanCheck();
			this._PopupScanCheck.init();
		}

		// Delegated handlers — popup HTML is replaced after AJAX/deeplink processing,
		// so direct bindings on #run-check would point at detached nodes.
		this._$mobilePopupHolder.off('click.popupMbScan', '#run-check');
		this._$mobilePopupHolder.on('click.popupMbScan', '#run-check', (e) => {
			e.preventDefault();
			e.stopPropagation();

			const $popup = this._$mobilePopupHolder.find('.ppc-exit-popup.safety-check').first();
			if ($popup.length) {
				this._PopupScanCheck.scan($popup);
			}
		});

		this._$mobilePopupHolder.off('click.popupMbClose', '.popup-close');
		this._$mobilePopupHolder.on('click.popupMbClose', '.popup-close', (e) => {
			e.preventDefault();
			e.stopPropagation();
			this._hidePopup();
		});

		this._$mobilePopupHolder.off('click.popupMbCta', '.cta-holder .main-cta');
		this._$mobilePopupHolder.on('click.popupMbCta', '.cta-holder .main-cta', () => {
			this._hidePopup();
			this._hideButton();
		});

		this._$mobilePopupHolder.off('click.popupMbHref', '[data-href]');
		this._$mobilePopupHolder.on('click.popupMbHref', '[data-href]', (e) => {
			if ($(e.target).hasClass('unbind-data-href') || $(e.target).closest('.unbind-data-href').length) {
				return;
			}
			if ($(e.currentTarget).hasClass('vpnmentor-exit-intent')) {
				this._hidePopup();
				this._hideButton();
			}
		});
	}

	_isTabletLayout() {
		return !Device.isMobile() && (
			Device.isTablet() ||
			Device.isTabletLandscape() ||
			Device.isIPad() ||
			Device.isAndroidTablet()
		);
	}

	_applyPopupLayout() {
		this._$mobilePopupHolder.toggleClass('is-tablet-centered', this._isTabletLayout());
	}

	_openPopupPanel() {
		const $holder = this._$mobilePopupHolder;

		if (this._isTabletLayout()) {
			$holder
				.css({
					display: 'block',
					visibility: 'visible',
					opacity: '0',
				});
			animate.fadeIn($holder);
		} else {
			animate.slideToggle($holder);
		}
	}

	_closePopupPanel() {
		if (this._isTabletLayout()) {
			animate.fadeOut(this._$mobilePopupHolder);
		} else {
			animate.slideToggle(this._$mobilePopupHolder);
		}
	}

	hide() {
		this._hideButton();
		this._teardownRevealListeners();
	}

	init() {
		this._$button.find('.popup-mb-launcher-x').off('click.popupMb').on('click.popupMb', (e) => {
			e.stopPropagation();
			e.preventDefault();
			this._hideButton();
		});

		const openPopup = (e) => {
			if ($(e.target).closest('.popup-mb-launcher-x').length) {
				return;
			}

			e.stopPropagation();
			e.preventDefault();
			this._requestShowPopup();
		};

		this._$button.off('click.popupMb').on('click.popupMb', openPopup);

		$(document).off('click.popupMbOutside').on('click.popupMbOutside', (e) => {
			if (!this._isPopupOpen) {
				return;
			}

			const isClickInsidePopup = $(e.target).closest('#mobile-popup-holder, .ppc-exit-popup, .popup-mb-overlay').length;
			const isClickInsideButton = $(e.target).closest('#show-popup-on-button').length;

			if (!isClickInsidePopup && !isClickInsideButton) {
				this._hidePopup();
			}
		});

		this._$mobilePopupHolder.off('click.popupMb', '.popup-close-button').on('click.popupMb', '.popup-close-button', (e) => {
			e.stopPropagation();
			e.preventDefault();
			this._hidePopup();
		});
	}

	_requestShowPopup() {
		if (!this._popupReady) {
			this._pendingShow = true;

			if (this._onRequestContent) {
				this._onRequestContent();
			}

			return;
		}

		this._showPopup();
	}

	_showPopup() {
		this._refreshDomRefs();

		if (!this._$mobilePopupHolder.find('.mobile-popup').children().length) {
			return;
		}

		if (this._isPopupOpen) {
			return;
		}

		this._applyPopupLayout();
		this._$overlay.addClass('is-open');
		$('body').addClass('no-scroll');
		this._openPopupPanel();
		this._isPopupOpen = true;
		this._hideButton();

		Cookie.set('_exit_ppc_pp', true);
	}

	_hidePopup() {
		if (!this._isPopupOpen) {
			return;
		}

		this._closePopupPanel();
		this._isPopupOpen = false;
		this._showButon();
		this._$overlay.removeClass('is-open');
		$('body').removeClass('no-scroll');
	}

	_showButon() {
		this._$button
			.removeClass('hidden is-hidden')
			.css({
				display: 'inline-flex',
				opacity: '1',
				transform: 'none',
				animation: 'none',
			});

		const buttonEl = this._$button[0];
		if (buttonEl) {
			void buttonEl.offsetHeight;
		}
	}

	_hideButton() {
		this._$button.addClass('hidden');
	}
}

export default PopupMobileButton;
